<template>
  <div class="collection-action-button__header-text">
    <v-btn
      :target="target"
      :href="link"
      class="nav-card-action"
      @click="onClickLink">
      <span class="collection-action-button__header-span">
        <template v-if="!useFollowLaterTradeshowFlow">
          Follow
        </template>
        <template v-else>
          Follow and save collection for later
        </template>
      </span>
    </v-btn>
    <app-dialog
      v-model="dialog"
      content-class="v-dialog__form"
      width="637">
      <div class="dialog-content">
        <v-card>
          <v-card-title>
            <div class="d-flex align-center">
              Let's make it easy
            </div>
            <v-icon
              color="#fff"
              @click="dialog = false">
              mdi-close
            </v-icon>
          </v-card-title>
          <v-card-text class="text-center d-flex flex-column align-center">
            <div style="font-size: 16px">
              You are not signed up or in, no problem :)
            </div>
            <v-btn
              class="mt-6"
              color="lightBlue"
              :target="target"
              :href="link">
              Save on Sourcery!
            </v-btn>
            <v-btn
              class="mt-3"
              color="lightGrey"
              @click="openEmailDialog">
              Send via email
            </v-btn>
          </v-card-text>
        </v-card>
      </div>
    </app-dialog>
    <app-dialog
      v-model="emailDialog"
      content-class="v-dialog__form"
      width="637">
      <div class="dialog-content">
        <v-card>
          <v-card-title>
            <div class="d-flex align-center">
              Enter email
            </div>
            <v-icon
              color="#fff"
              @click="emailDialog = false">
              mdi-close
            </v-icon>
          </v-card-title>
          <v-card-text>
            <v-form
              ref="tradeShowFlowForm"
              lazy-validation
              @submit.prevent>
              <v-col
                cols="12"
                lg="8"
                xl="7"
                md="9">
                <v-text-field
                  v-model="email"
                  :rules="[rules.required, rules.email]"
                  validate-on-blur
                  solo
                  single-line
                  filled
                  dense
                  placeholder="email" />
              </v-col>
            </v-form>
          </v-card-text>
          <v-card-actions class="pt-6 d-flex justify-end">
            <v-btn
              outlined
              color="lightBlue"
              @click="emailDialog = false">
              Cancel
            </v-btn>
            <v-btn
              color="lightBlue"
              @click="sendEmail">
              Send
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </app-dialog>
  </div>
</template>
<script>
import {
  mapActions, mapGetters, mapState,
} from 'vuex';
import { Auth } from 'aws-amplify';
import collections from '@/services/graphql/collections';
import { waitTimeout } from '@/utils';
export default {
  name: 'FollowLinkBtn',
  props: {
    link: {
      type: String,
      required: true,
    },
    target: {
      type: String,
      default: 'blank',
    },
  },
  data() {
    return {
      dialog: false,
      emailDialog: false,
      email: '',
      rules: {
        required: value => !!value || 'This field is required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        },
      },
    };
  },
  computed: {
    ...mapGetters('FeatureFlags', ['useFollowLaterTradeshowFlow']),
    ...mapState(['activeHeader']),
  },
  watch: {
    async emailDialog(value) {
      if (!value) return;
      await waitTimeout(200);
      this.$refs.tradeShowFlowForm.resetValidation();
      this.email = '';
    },
  },
  methods: {
    ...mapActions(['handleError']),
    async onClickLink(e) {
      if (!this.useFollowLaterTradeshowFlow) return;
      try {
        await Auth.currentAuthenticatedUser();
      } catch (error) {
        if (!this.useFollowLaterTradeshowFlow) return;
        e.preventDefault();
        this.dialog = true;
      }
    },
    async openEmailDialog() {
      this.dialog = false;
      this.emailDialog = true;
    },
    async sendEmail() {
      try {
        if (!this.$refs.tradeShowFlowForm.validate()) return;
        await collections.tradeShowSendEmail({
          email: this.email,
          collectionName: this.activeHeader?.name,
          quickLink: window.location.href,
        });
        this.emailDialog = false;
      } catch (e) {
        this.handleError(e);
      } finally {
        this.dialog = false;
      }
    },
  },
};
</script>
<style scoped>
</style>
